import { useFlags } from 'launchdarkly-react-client-sdk';

import { BillingDelinquencyTier } from '~constants/billing/delinquency';
import { LDFlags } from '~types/featureFlags';
import { getBillingDelinquencyTier } from '~utils/billing/billingDelinquencyTier';

/** No wait for LaunchDarkly identify: like every flag, treatment lands a beat late. */
export const useBillingDelinquency = (): BillingDelinquencyTier | null =>
	getBillingDelinquencyTier(useFlags<LDFlags>());
